module.exports = __webpack_public_path__ + "static/img/xtdx.710516a4.jpg";